import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "form"];

  connect() {
    console.log("OTP Controller Connected");
    this.focusFirstInput();
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.inputTargets.forEach((input, index) => {
      input.addEventListener("input", (e) => this.handleInput(e, index));
      input.addEventListener("keydown", (e) => this.handleKeydown(e, index));
      input.addEventListener("paste", (e) => this.handlePaste(e));
      input.setAttribute("aria-invalid", "false");
    });
  }

  handleInput(event, index) {
    const input = event.target;
    const value = input.value.replace(/[^0-9]/g, "").slice(0, 1);

    input.value = value;
    input.setAttribute("aria-invalid", value ? "false" : "true");

    if (value && index < this.inputTargets.length - 1) {
      this.inputTargets[index + 1].focus();
    }

    if (this.isComplete()) {
      this.submit();
    }
  }

  handleKeydown(event, index) {
    const { key } = event;
    const input = event.target;

    if (key === "Backspace" && !input.value && index > 0) {
      this.inputTargets[index - 1].focus();
    } else if (key === "ArrowLeft" && index > 0) {
      event.preventDefault();
      this.inputTargets[index - 1].focus();
    } else if (key === "ArrowRight" && index < this.inputTargets.length - 1) {
      event.preventDefault();
      this.inputTargets[index + 1].focus();
    }
  }

  handlePaste(event) {
    event.preventDefault();
    const digits = event.clipboardData
      .getData("text")
      .replace(/[^0-9]/g, "")
      .slice(0, this.maxLengthValue)
      .split("");

    this.inputTargets.forEach((input, i) => {
      const value = digits[i] || "";
      input.value = value;
      input.setAttribute("aria-invalid", value ? "false" : "true");
    });

    if (this.isComplete()) {
      this.submit();
    } else {
      this.focusNextEmpty();
    }
  }

  handleSubmit(event) {
    // Handle Turbo Stream response
    if (event.detail.success) {
      const response = event.detail.fetchResponse;
      if (response.redirected) {
        Turbo.visit(response.response.url);
      }
    }
  }

  submit() {
    const otpCode = this.inputTargets.map((input) => input.value).join("");

    // Find form and create/update hidden input
    const form = this.element.querySelector("form");
    const hiddenInput =
      form.querySelector('input[name="otp_attempt"]') ||
      this.createHiddenInput(form);
    hiddenInput.value = otpCode;

    // Submit form
    try {
      form.requestSubmit();
    } catch (e) {
      console.error("Submit failed:", e);
      form.submit(); // Fallback
    }
  }

  createHiddenInput(form) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "otp_attempt";
    form.appendChild(input);
    return input;
  }

  isComplete() {
    const isValid = this.inputTargets.every((input) =>
      /^[0-9]$/.test(input.value)
    );
    console.log("OTP Complete:", isValid); // Debug log
    return isValid;
  }

  focusFirstInput() {
    requestAnimationFrame(() => {
      this.inputTargets[0]?.focus();
    });
  }

  focusNextEmpty() {
    const nextEmpty = this.inputTargets.find((input) => !input.value);
    nextEmpty?.focus();
  }
}
